import React from 'react';
import './AboutHeading.css';

function AboutHeading() {
  return (
      <div className='about-heading-wrapper'>
          <div className='about-heading'>
              ABOUT ME
          </div>
          <div className='about-heading-line'/>
      </div>
  );
};

export default AboutHeading;